import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { Logo } from "./SiteNav";

const GROUPS = {
  en: [
    ["Create", [["AI Video Generator", "/ai-video-generator"], ["Text to Video", "/text-to-video"],
      ["Image to Video", "/image-to-video"], ["AI Movie Maker", "/ai-movie-maker"],
      ["AI Storyboard", "/ai-storyboard-generator"], ["AI Character", "/ai-character-generator"]]],
    ["Styles", [["Cinematic", "/cinematic-ai-video"], ["Hollywood", "/hollywood-ai-video"],
      ["Anime", "/anime-ai-video"], ["Cartoon", "/cartoon-ai-video"],
      ["Luxury", "/luxury-ai-video"], ["Sci-Fi", "/sci-fi-ai-video"]]],
    ["Use cases", [["TikTok", "/ai-video-for-tiktok"], ["Instagram", "/ai-video-for-instagram"],
      ["YouTube", "/ai-video-for-youtube"], ["Advertising", "/ai-video-for-ads"],
      ["Ecommerce", "/ai-video-for-ecommerce"], ["Filmmakers", "/ai-video-for-filmmakers"]]],
    ["Company", [["Pricing", "/pricing"], ["Templates", "/templates"], ["Blog", "/blog"],
      ["Enterprise", "/enterprise"], ["API", "/api-docs"], ["Affiliate", "/affiliate"],
      ["Contact", "/contact"], ["About", "/about"], ["Careers", "/careers"]]],
    ["Legal", [["Terms", "/legal/terms"], ["Privacy", "/legal/privacy"],
      ["Refunds", "/legal/refund-policy"], ["Cookies", "/legal/cookies"],
      ["Acceptable use", "/legal/acceptable-use"], ["Copyright", "/legal/copyright"],
      ["AI policy", "/legal/ai-policy"]]],
  ],
  fr: [
    ["Créer", [["Générateur vidéo IA", "/generateur-video-ia"], ["Texte vers vidéo", "/texte-vers-video"],
      ["Image vers vidéo", "/image-vers-video"], ["Créateur de film IA", "/createur-de-film-ia"],
      ["Storyboard IA", "/generateur-storyboard-ia"], ["Personnage IA", "/generateur-personnage-ia"]]],
    ["Styles", [["Cinématique", "/video-ia-cinematic"], ["Hollywood", "/video-ia-hollywood"],
      ["Anime", "/video-ia-anime"], ["Cartoon", "/video-ia-cartoon"],
      ["Luxe", "/video-ia-luxury"], ["Sci-Fi", "/video-ia-sci-fi"]]],
    ["Cas d'usage", [["TikTok", "/video-ia-pour-tiktok"], ["Instagram", "/video-ia-pour-instagram"],
      ["YouTube", "/video-ia-pour-youtube"], ["Publicité", "/video-ia-pour-ads"],
      ["E-commerce", "/video-ia-pour-ecommerce"], ["Réalisateurs", "/video-ia-pour-filmmakers"]]],
    ["Société", [["Tarifs", "/pricing"], ["Templates", "/templates"], ["Blog", "/blog"],
      ["Entreprise", "/enterprise"], ["API", "/api-docs"], ["Affiliation", "/affiliate"],
      ["Contact", "/contact"], ["À propos", "/about"], ["Carrières", "/careers"]]],
    ["Légal", [["CGU", "/legal/terms"], ["Confidentialité", "/legal/privacy"],
      ["Remboursements", "/legal/refund-policy"], ["Cookies", "/legal/cookies"],
      ["Charte d'usage", "/legal/acceptable-use"], ["Droit d'auteur", "/legal/copyright"],
      ["Politique IA", "/legal/ai-policy"]]],
  ],
};

export default function SiteFooter() {
  const { locale, t } = useI18n();
  const L = (p) => `/${locale}${p}`;
  return (
    <footer className="border-t border-white/[0.07] bg-[#07070a] px-6 pb-12 pt-20 lg:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(5,1fr)]">
          <div>
            <Logo />
            <p className="mt-5 max-w-[260px] text-sm leading-relaxed text-[#9194a6]">
              {locale === "fr"
                ? "Studio de production audiovisuelle IA. Idée, scénario, storyboard, plans, montage, film."
                : "AI film production studio. Idea, script, storyboard, shots, edit, film."}
            </p>
            <p className="mono mt-6 text-[11px] text-[#8288a0]">studiomoviesia.com</p>
            <a href="mailto:studiomoviesia@gmail.com" className="mono mt-1.5 block text-[11px] text-[#ffc76b]" data-testid="footer-contact-email">
              studiomoviesia@gmail.com
            </a>
          </div>
          {GROUPS[locale].map(([title, items]) => (
            <div key={title}>
              <p className="overline mb-4">{title}</p>
              <ul className="space-y-2.5">
                {items.map(([label, to]) => (
                  <li key={to}>
                    <Link
                      to={L(to)}
                      className="text-[13px] text-[#9194a6] transition-colors duration-200 hover:text-white"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-white/[0.06] pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="mono text-[11px] text-[#8288a0]">
            © {new Date().getFullYear()} Studio Movies IA — {t("footer.rights")}
          </p>
          <p className="mono text-[11px] text-[#8288a0]">Web · PWA · iOS · Android</p>
        </div>
      </div>
    </footer>
  );
}
